"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var React = __importStar(require("react"));
var TimePicker = (function (props) {
    var _a;
    var onSelect = props.onSelect, onChange = props.onChange, value = props.value;
    var _b = __read(React.useState(value), 2), time = _b[0], setTime = _b[1];
    var savedDateStr = React.useRef("");
    /** This handles the user selecting a value */
    var newOnSelect = React.useCallback(function (newTime) {
        setTime(newTime);
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(newTime);
        /**
         * onChange has to be called here because the wrapping Form.Item uses this to detect
         * and maintain it's internal state
         * */
        onChange === null || onChange === void 0 ? void 0 : onChange(newTime, savedDateStr.current);
    }, [onSelect, onChange]);
    /** This handles the user clicking the X to clear the value */
    var newOnChange = React.useCallback(function (newTime, dateStr) {
        setTime(newTime);
        savedDateStr.current = dateStr;
        onChange === null || onChange === void 0 ? void 0 : onChange(newTime, dateStr);
    }, [onChange]);
    /** Styles to remove the footer */
    var popupClassName = !props.showNow
        ? ((_a = props.popupClassName) !== null && _a !== void 0 ? _a : "") + " hide-footer"
        : props.popupClassName + " hide-ok";
    return (React.createElement(antd_1.TimePicker, __assign({}, props, { onSelect: newOnSelect, onChange: newOnChange, popupClassName: popupClassName, value: value !== null && value !== void 0 ? value : time })));
});
exports.default = TimePicker;
//# sourceMappingURL=index.js.map